import { useEffect, useState } from 'react';
import {
  getManifest,
  heroPiece,
  heroSlides,
  originalsForSale,
  piecesFor,
  type ArtworkManifest,
  type ArtworkPiece,
  type Placement,
} from '../lib/artwork';

export function useManifest(): ArtworkManifest {
  const [manifest, setManifest] = useState(getManifest);
  useEffect(() => {
    const refresh = () => setManifest(getManifest());
    window.addEventListener('su-artwork-changed', refresh);
    window.addEventListener('storage', refresh);
    window.addEventListener('su-content-changed', refresh);
    return () => {
      window.removeEventListener('su-artwork-changed', refresh);
      window.removeEventListener('storage', refresh);
      window.removeEventListener('su-content-changed', refresh);
    };
  }, []);
  return manifest;
}

export function usePieces(placement: Placement, featuredOnly = false) {
  const manifest = useManifest();
  return piecesFor(placement, { featuredOnly }).filter((p) =>
    manifest.pieces.some((m) => m.id === p.id),
  );
}

export function useHero() {
  useManifest();
  return heroPiece();
}

export function useHeroSlides(): ArtworkPiece[] {
  useManifest();
  return heroSlides(4);
}

export function useOriginals() {
  useManifest();
  return originalsForSale();
}
